import type { SongMeta } from '@/types';
import { generateChart } from '@/utils/chartGenerator';

const bpm = 140;
const duration = 42;

export const midnightSnackSong: SongMeta = {
  id: 'midnight-snack',
  title: 'Midnight Snack',
  artist: 'Meow Melody Studio',
  bpm,
  duration,
  audio: 'synth',
  synthTrack: 'popLoop',
  difficulty: 4,
  background: 'candyNight',
  chart: generateChart({ bpm, durationSec: duration, stepBeats: 0.5, noteTravelTime: 1.6 }),
};
